import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  TBctxHeaderItem,
  TBctxWipMap,
  TGradingPageAction,
  TVariableGroupFieldsInfo,
  TSizeMapItem,
} from '@monorepo/types';
import { SizeFilterComponent } from '../size-filter/size-filter.component';
import { InputAppAPIHelperUtil } from '@monorepo/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'monorepo-grading-page',
  templateUrl: './grading-page.component.html',
  styleUrls: ['./grading-page.component.scss'],
})
export class GradingPageComponent implements OnInit, OnChanges {
  @Input() actionType: TGradingPageAction = 'FTT';
  @Input() bctxHeader: TBctxHeaderItem[] = [];
  @Input() sizeList: TSizeMapItem[] = [];
  @Input() isProceedDisabled = true;
  @Input() bctxKey: string = '';
  @Input() bctxWipMap: TBctxWipMap = {};
  @Input() filteredSizesListByBctx: string[] = [];
  @Input() enableBulkChange = true;
  @Input() isWipValidationEnabledLineIn: boolean = false;
  @Input() quantityOptions: number[] = [1, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
  @Input() count = 1;
  @Input() variableGroupFieldsInfo: TVariableGroupFieldsInfo[] = [];
  @Input() appIdentifier: string | boolean = '';

  @Output() proceed = new EventEmitter<string>();
  @Output() exit = new EventEmitter<string>();
  @Output() updatedSize = new EventEmitter<string>();
  @Output() undo = new EventEmitter<string>();
  @Output() bulkCount = new EventEmitter<number>();
  @Output() sync = new EventEmitter<string>();
  @Output() updateFilteredSizesListByBctx = new EventEmitter<string[]>();

  totalActuals = 0;
  visibleSizeList: TSizeAndVisibleStatus[] = [];

  undoIcon = '/assets/md-point/undo-icon.svg';
  sizeFilterIcon = '/assets/md-point/size-filter.svg';
  syncIcon = '/assets/md-point/sync-icon.svg';
  proceedIcon = '/assets/fabric-inspection/proceed-icon.svg';
  goBackIcon = '/assets/left-arrow.svg';

  constructor(
    private modalController: ModalController,
    private inputAppAPIHelperUtil: InputAppAPIHelperUtil,

    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    console.log('SIZE_LIST', this.sizeList);
    const activeSizeList = this.sizeList.filter((list) => list.isInactive === undefined || list.isInactive === false);
    if (activeSizeList.length === 0) {
      this.inputAppAPIHelperUtil.showPopup(
        this.translate.instant('grading_page_container.sizeListError.header'),
        this.translate.instant('grading_page_container.sizeListError.message'),
      );
    } else {
      this.#updateVisibleListAndTotalActuals();
    }
  }

  trackByFn(index: number, item: TSizeMapItem) {
    return item.client_work[this.actionType];
  }

  #updateVisibleListAndTotalActuals() {
    this.sizeList = this.sizeList.filter((ele) => ele.name && ele.name != 'undefined');
    const visibleSizeList: TSizeAndVisibleStatus[] = [];
    if (this.filteredSizesListByBctx.length) {
      this.visibleSizeList = this.sizeList.reduce((acc, curr) => {
        if (this.filteredSizesListByBctx.includes(curr.name)) acc.push({ size: curr.name, status: true });
        else acc.push({ size: curr.name, status: false });
        return acc;
      }, [] as TSizeAndVisibleStatus[]);
    } else {
      this.sizeList.map((sizeItem) => {
        const visibleSizeListItem = this.visibleSizeList.find((item) => item.size === sizeItem.name);
        if (visibleSizeListItem) visibleSizeList.push(visibleSizeListItem);
        else visibleSizeList.push({ size: sizeItem.name, status: true });
      });
      this.visibleSizeList = visibleSizeList;
    }
    this.updateTotalActuals();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('[Changes]', changes);
    if (changes['sizeList']) {
      this.#updateVisibleListAndTotalActuals();
    }
  }

  notifyUpdateSizeListIndex(sizeName: string) {
    this.updatedSize.emit(sizeName);
  }

  updateTotalActuals() {
    let total = 0;
    this.sizeList.forEach((item, index) => {
      total += item.client_work[this.actionType].actuals;
    });

    this.totalActuals = total;
  }

  async filterSizeItem() {
    const popup = await this.modalController.create({
      component: SizeFilterComponent,
      componentProps: {
        sizeList: this.sizeList,
        filteredList: this.visibleSizeList.map((item) => item.status),
      },
      backdropDismiss: true,
    });
    popup.present();
    popup.onDidDismiss().then((res) => {
      console.log('[DATA]', res);
      if (res.data) {
        this.visibleSizeList = this.visibleSizeList.map((item, index) => {
          return { ...item, status: res.data[index] };
        });
        this.updateFilteredSizesListByBctx.emit(
          this.visibleSizeList.filter((item) => item.status).map((item) => item.size),
        );
      }
    });
  }

  handleExit() {
    this.exit.emit('EXIT');
  }

  handleProceed() {
    this.proceed.emit('SAVE_WORK');
  }

  handleUndo() {
    this.undo.emit('UNDO');
  }

  handleBulkCount(bulkCount: number) {
    console.log('[PRESENTATION]', bulkCount);
    this.bulkCount.emit(bulkCount);
  }

  handleSync() {
    this.sync.emit('SYNC');
  }
}

type TSizeAndVisibleStatus = {
  size: string;
  status: boolean;
};
